import React, { useState } from 'react'
import { useParams } from 'react-router'
import { useAutoRefresh, useRemoteData } from 'lib/RemoteData'
import { API_HOST } from 'lib'
import { Container } from 'styles/PageLayout'
import { Link } from 'react-router'
import { InstallationAssortmentDatabase } from 'components/assortment/InstallationAssortmentDatabase'
import { SRD } from 'srd'
import { ArrowRightIcon } from '../../icons'
import HomeIcon from '../../icons/HomeIcon'
import './components/CommonLink'
import { InstallationHeader } from './components/InstallationHeader'
import { InstallationViewDTO } from '../../domain/InstallationViewDTO'

export const InstallationView = () => {
  const { id } = useParams<{ id: string }>()
  const { filetype } = useParams<{ filetype: string }>()
  const [overrideRevision, setOverrideRevision] = useState(0)

  const { data: installationRemoteData, refresh: refreshInstallation } = useRemoteData<InstallationViewDTO>(
    `${API_HOST}/bff/installations/${id}`,
  )
  useAutoRefresh(refreshInstallation, 60000)

  return SRD.match(
    {
      notAsked: () => <div>Empty</div>,
      loading: () => (
        <div className="card">
          <div className="loadingSpinner" />
        </div>
      ),
      failure: (err) => (
        <div className="card">
          <div className="centerAbsolute">
            <div className="alert alert-danger">
              Uh-oh.. Failed to load installation details
              <div>{err.body?.title}</div>
            </div>
          </div>
        </div>
      ),
      success: (installationView) => {
        const { installation, commonAssortment } = installationView

        return (
          <div>
            <div className="py-md px-lg flex items-center space-x-md">
              <Link aria-label="Home" to={'/'}>
                <HomeIcon size="1.5rem" />
              </Link>
              <ArrowRightIcon size="1rem" />
              <Link to="/installations">
                <h2>Installations</h2>
              </Link>
              <ArrowRightIcon size="1rem" />
              <h2>{installation.installationReference.serialNumber}</h2>
            </div>
            <div className="card">
              <Container>
                <InstallationHeader
                  installationView={installationView}
                  refresh={refreshInstallation}
                  history={installation.history}
                  commonIsLocked={!!commonAssortment && commonAssortment.lockout}
                  onOverridesRecovered={() => {
                    setOverrideRevision((revision) => revision + 1)
                    refreshInstallation()
                  }}
                />
                {commonAssortment.commonAssortmentId && (
                  <div>
                    <InstallationAssortmentDatabase
                      key={`${installation.installationReference.installationId}-${overrideRevision}`}
                      initialTab={filetype}
                      commonId={commonAssortment.commonAssortmentId}
                      installationId={installation.installationReference.installationId}
                      history={installation.history}
                      serialNumber={installation.installationReference.serialNumber}
                    />
                  </div>
                )}
              </Container>
            </div>
          </div>
        )
      },
    },
    installationRemoteData,
  )
}
